const translations = {
  pl: {
    title: "TapLab — breloki NFC z druku 3D",
    nav_product: "Produkt",
    nav_how: "Jak działa",
    nav_plaques: "Tabliczki",
    nav_uses: "Zastosowania",
    nav_price: "Cennik",
    nav_faq: "FAQ",
    nav_contact: "Kontakt",
    menu_open: "Otwórz menu",
    menu_close: "Zamknij menu",
    hero_eye: "Breloki NFC · druk 3D FDM",
    hero_h: "Zbliż telefon. Gotowe.",
    hero_h_html: "Zbliż telefon.<br><em>Gotowe.</em>",
    btn_explore: "Zobacz cennik →",
    hero_trust: "FDM · NTAG213 · bez aplikacji",
    theme_toggle: "Przełącz motyw",
    meta3: "materiał",
    meta4: "częstotliwość",
    p1_badge: "Najczęściej",
    p3_upto: "przy większej serii",
    foot_about: "Podmarka GO!soda. Breloki i tabliczki NFC z druku 3D.",
    foot_home: "Strona główna",
    tools_eye: "Pobieranie",
    tools_h: "NFC Tools",
    tools_p: "Darmowa aplikacja do zapisu linku, wizytówki albo Wi‑Fi na chipie w breloku TapLab. Wybierz sklep swojego telefonu.",
    tools_android: "Pobierz na Androida",
    tools_ios: "Pobierz na iPhone’a",
    err_eye: "Brak strony",
    err_h: "Tu nic nie ma",
    err_p: "Ten adres nie należy do TapLab. Link jest błędny albo strona została usunięta.",
    err_home: "Wróć na stronę główną",
    hero_lead: "Mały brelok z chipem NFC w środku. Jeden tap otwiera stronę, wizytówkę, profil albo sieć Wi‑Fi. Drukujemy go warstwa po warstwie i zamykamy chip w plastiku, żeby był trwały na co dzień.",
    btn_contact: "Kontakt",
    btn_see: "Zobacz produkt",
    meta1: "bez aplikacji",
    meta2: "chip w środku",
    float1: "Chip schowany w wydruku",
    float2: "Zbliżasz telefon i działa",
    prod_eye: "Produkt",
    prod_h: "Brelok, który zastępuje wizytówkę i kod QR",
    prod_p: "TapLab to niewielki gadżet z kluczami. W środku siedzi pasywny chip NFC — bez baterii, bez ładowania. Telefon sam go zasila na ułamek sekundy i odczytuje zapisaną informację.",
    c1_h: "Własny kształt",
    c1_p: "Sześciokąt, kropla, misiek, góry, prostokąt albo Twój pomysł. Druk 3D pozwala zrobić serię albo jeden unikat.",
    c2_h: "Chip zamknięty w plastiku",
    c2_p: "Tag wkładamy w trakcie druku i zamykamy kolejnymi warstwami. Chip jest chroniony przed zarysowaniami i codziennym noszeniem.",
    c3_h: "Działa na telefonach",
    c3_p: "Android i iPhone z NFC. Odbiorca nic nie instaluje — wystarczy zbliżyć telefon do breloka.",
    pl_eye: "Tabliczki NFC",
    pl_h: "Oceń nas na Google — jedno tapnięcie",
    pl_p: "Tabliczka stoi przy kasie albo na stoliku. Gość zbliża telefon i od razu otwiera się Wasza wizytówka Google do wystawienia opinii. Bez QR, bez przepisywania linku. Wersja biała albo czarna, chip NTAG213 w środku, PLA.",
    pl_black: "Wersja czarna",
    pl_white: "Wersja biała",
    pl1_h: "Opinie Google",
    pl1_p: "Programujemy chip na Wasz profil Google. Klient tapnie i wystawia gwiazdki, zamiast szukać firmy w wyszukiwarce.",
    pl2_h: "10 × 15 cm",
    pl2_p: "Prostokąt 150 cm² — ten z oferty. Kwadrat i okrąg też są. Większy format wyceniamy osobno. Logo albo inny napis na życzenie.",
    pl3_h: "60 zł brutto",
    pl3_p: "Jedna tabliczka z chipem i nadrukiem. Realizacja 4–7 dni. Sprawdzi się w lokalu, gabinecie, sklepie i na recepcji.",
    how_eye: "Jak to działa",
    how_h: "Trzy kroki od pomysłu do tapnięcia",
    s1_h: "Wybierasz kształt i kolor",
    s1_p: "Gotowy model z katalogu albo własny projekt. Materiał: PLA — do codziennego użytku.",
    s2_h: "Drukujemy i chowamy chip",
    s2_p: "Drukarka zatrzymuje się w połowie. Wkładamy okrągły tag NTAG213 (25 mm) i dokańczamy wydruk, aż plastik go zamknie.",
    s3_h: "Programujesz jednym tapem",
    s3_p: "Darmowa aplikacja NFC Tools zapisuje link, wizytówkę vCard, Wi‑Fi albo profil. Później możesz to zmienić — chip jest wielokrotnego zapisu.",
    s3_link: "Pobierz NFC Tools",
    use_eye: "Po co to nosić",
    use_h: "Jeden brelok, wiele zastosowań",
    u1_h: "Wizytówka",
    u1_p: "Zamiast kartki — tap i kontakt ląduje w telefonie.",
    u2_h: "Social media",
    u2_p: "Instagram, TikTok, YouTube albo portfolio. Szybko, bez literówek.",
    u3_h: "Wi‑Fi dla gości",
    u3_p: "Gość zbliża telefon i łączy się z siecią. Hasło zostaje w breloku.",
    u4_h: "Prezent i branding",
    u4_p: "Gadżet z kształtem firmy, szkoły albo wydarzenia. Mały, ale zapamiętywalny.",
    shop_eye: "Warsztat",
    shop_h: "Druk FDM, nie forma wtryskowa",
    shop_p: "Każdy brelok powstaje warstwa po warstwie. Dzięki temu można robić krótkie serie, testować nowe kształty i mieszać kolory bez drogiej formy. Chip wchodzi do kieszonki w trakcie druku — nie trzeba go kleić na wierzchu.",
    sp1: "Technologia",
    sp2: "Materiał",
    sp2v: "PLA",
    sp3: "Chip",
    sp4: "Pamięć",
    sp4v: "144 albo 504 B",
    sp5: "Częstotliwość",
    sp6: "Rozmiar tagu",
    sp7: "Waga breloka",
    sp7v: "ok. 5–10 g",
    sp8: "Zasilanie",
    sp8v: "brak baterii",
    gal_eye: "Galeria",
    gal_h: "Tak wygląda na kluczach",
    pr_eye: "Cennik",
    pr_h: "Breloczek albo tabliczka",
    pr_p: "Ceny brutto za sztukę. Kształt, kolor i programowanie chipu w cenie.",
    p1_h: "Breloczek NFC",
    p1_s: "Koło, kwadrat albo łza",
    p1_l1: "Do ok. 4 cm, metalowa zawieszka",
    p1_l2: "Chip NFC w wydruku",
    p1_l3: "Maks. 4 kolory",
    p1_l4: "Programowanie linku w cenie",
    p2_h: "Tabliczka NFC",
    p2_s: "Kwadrat, okrąg, prostokąt",
    p2_l1: "Prostokąt 10 × 15 cm (150 cm²)",
    p2_l2: "Wersja biała albo czarna",
    p2_l3: "Logo lub napis na froncie",
    p2_l4: "Chip NFC pod opinie / stronę",
    p3_h: "Rabaty ilościowe",
    p3_s: "Im większa seria, tym taniej",
    p3_l1: "Breloczki: 50 / 100 / 200 szt. → 5 / 8 / 10%",
    p3_l2: "Tabliczki: 5 / 15 / 30 szt. → 5 / 8 / 10%",
    p3_l3: "Zaliczka 30%, reszta przed wysyłką",
    p3_l4: "Realizacja 4–7 dni roboczych",
    btn_write: "Napisz",
    per: "brutto / szt.",
    from: "od",
    faq_eye: "Pytania",
    faq_h: "Krótko i konkretnie",
    f1_q: "Czy potrzebuję aplikacji, żeby odczytać brelok?",
    f1_a: "Nie. Osoba, której pokazujesz brelok, tylko zbliża telefon. Aplikacja jest potrzebna wyłącznie do pierwszego zapisu albo zmiany treści.",
    f2_q: "Czym są tabliczki/breloczki NFC od TapLab?",
    f2_a: "To fizyczne nośniki (tabliczki, breloczki) z wbudowanym chipem NFC, który po zbliżeniu telefonu automatycznie otwiera wybrany link — np. do menu, wizytówki Google, profilu społecznościowego czy formularza opinii. Wystarczy przyłożyć telefon, bez skanowania kodu.",
    f3_q: "Czy mój telefon obsługuje NFC?",
    f3_a: "Większość smartfonów z ostatnich kilku lat (Android i iPhone) ma NFC wbudowane fabrycznie. W Androidzie czasem trzeba go włączyć w ustawieniach — pokażemy Ci jak, jeśli będzie potrzeba.",
    f4_q: "Czy link można zmienić po zakupie?",
    f4_a: "Tak, w większości naszych produktów tag jest zapisywalny — możesz zmienić docelowy link w dowolnym momencie, bez wymiany samej tabliczki czy breloczka.",
    f5_q: "Jakie kształty i wzory są dostępne?",
    f5_a: "Tabliczki NFC: kwadrat, okrąg, prostokąt. Breloczki NFC: okrąg, kółko, kropla. Każdy produkt można spersonalizować pod Twoją markę.",
    f6_q: "Ile kosztuje zamówienie?",
    f6_a: "Tabliczki NFC — 60 zł brutto/szt., breloczki NFC — 13 zł brutto/szt. Przy większych zamówieniach obowiązują rabaty: od 5 szt. — 5%, od 15 szt. — 8%, od 30 szt. — 12%, a przy zamówieniach od 50 szt. dodatkowe rabaty.",
    f7_q: "Ile trwa realizacja zamówienia?",
    f7_a: "Standardowo 4–7 dni roboczych. Przy zamówieniach powyżej 175 szt. czas realizacji może się wydłużyć — poinformujemy Cię o tym przed potwierdzeniem zamówienia.",
    f8_q: "Jak wygląda płatność?",
    f8_a: "30% zaliczki przy złożeniu zamówienia, pozostałe 70% przed wysyłką.",
    f9_q: "Czy w cenę wliczony jest projekt graficzny?",
    f9_a: "Tak, pierwsze 2 projekty graficzne są wliczone w cenę. Kolejne projekty są płatne dodatkowo.",
    f10_q: "Jak odbywa się dostawa?",
    f10_a: "Wysyłka kurierem na terenie całej Polski. Możliwy jest też odbiór lub dostawa osobisty na terenie Bydgoszczy.",
    f11_q: "Dla kogo są te produkty?",
    f11_a: "Dla firm i lokali, które chcą ułatwić klientom dostęp do menu, wizytówki, opinii Google czy social mediów — np. restauracje, kawiarnie, salony kosmetyczne, sklepy, hotele.",
    f12_q: "Jak złożyć zamówienie?",
    f12_a: "Napisz do nas przez formularz kontaktowy lub e-mail — omówimy szczegóły, wycenimy zamówienie i ustalimy termin. Każde zamówienie traktujemy indywidualnie, dlatego nie ma przycisku „Kup teraz”. Formularz pozwala dopasować projekt, ilość i termin do Twoich potrzeb. W trosce o satysfakcje z efektu końcowego.",
    ct_eye: "Kontakt",
    ct_h: "Wyślij zapytanie",
    ct_p: "Wybierz produkt, dopisz dane i opcjonalnie dodaj plik projektu. Wiadomość idzie na karol.lemanczyk@taplab.pl.",
    ct_mail: "E-mail",
    ct_tel: "Telefon",
    ct_loc: "Lokalizacja",
    ct_pl: "Bydgoszcz",
    made_in: "Wyprodukowano w Polsce",
    foot_info: "Informacje",
    foot_company: "Dane firmy",
    foot_social: "Śledź nas",
    foot_terms: "Regulamin",
    foot_privacy: "Polityka prywatności",
    foot1: "TapLab · Sebastian Lemańczyk",
    foot2: "Strona prezentacyjna produktu · 2026",
    form_product: "Produkt",
    form_keychain: "Breloczek",
    form_plaque: "Tabliczka",
    form_firstname: "Imię",
    form_lastname: "Nazwisko",
    form_email: "E-mail klienta",
    form_company: "Nazwa firmy (opcjonalnie)",
    form_desc: "Opis",
    form_file: "Projekt (opcjonalnie)",
    form_file_hint: "PNG, JPG, SVG, PDF, AI, EPS, ZIP, STL, 3MF i podobne.",
    form_send: "Wyślij",
    form_ok: "Wysłane. Sprawdź skrzynkę — pierwsze zgłoszenie może wymagać potwierdzenia adresu karol.lemanczyk@taplab.pl.",
    form_err: "Nie udało się wysłać. Spróbuj jeszcze raz albo napisz bezpośrednio na karol.lemanczyk@taplab.pl.",
    form_need: "Zaznacz produkt, wpisz ilość, imię, nazwisko, e-mail i opis."
  },
  en: {
    title: "TapLab — 3D-printed NFC keychains",
    nav_product: "Product",
    nav_how: "How it works",
    nav_plaques: "Plaques",
    nav_uses: "Uses",
    nav_price: "Pricing",
    nav_faq: "FAQ",
    nav_contact: "Contact",
    menu_open: "Open menu",
    menu_close: "Close menu",
    hero_eye: "NFC keychains · FDM 3D print",
    hero_h: "Tap your phone. Done.",
    hero_h_html: "Tap your phone.<br><em>Done.</em>",
    btn_explore: "See pricing →",
    hero_trust: "FDM · NTAG213 · no app",
    theme_toggle: "Toggle theme",
    meta3: "material",
    meta4: "frequency",
    p1_badge: "Most popular",
    p3_upto: "on larger runs",
    foot_about: "A GO!soda sub-brand. 3D-printed NFC keychains and plaques.",
    foot_home: "Home",
    tools_eye: "Download",
    tools_h: "NFC Tools",
    tools_p: "Free app to write a link, contact card or Wi‑Fi onto the chip in a TapLab keychain. Pick your phone store.",
    tools_android: "Get it on Android",
    tools_ios: "Get it on iPhone",
    err_eye: "Page missing",
    err_h: "Nothing here",
    err_p: "This address is not part of TapLab. The link is wrong or the page was removed.",
    err_home: "Back to home",
    hero_lead: "A small keychain with an NFC chip inside. One tap opens a page, a contact card, a profile or Wi‑Fi. We print it layer by layer and seal the chip in plastic so it holds up every day.",
    btn_contact: "Contact",
    btn_see: "See the product",
    meta1: "no app needed",
    meta2: "chip inside",
    float1: "Chip sealed in the print",
    float2: "Tap your phone and it works",
    prod_eye: "Product",
    prod_h: "A keychain that replaces a business card and a QR code",
    prod_p: "TapLab is a small gadget for your keys. Inside is a passive NFC chip — no battery, no charging. The phone powers it for a split second and reads what you saved.",
    c1_h: "Your own shape",
    c1_p: "Hexagon, drop, bear, mountains, rectangle or your idea. 3D printing lets us make a run or a single one-off.",
    c2_h: "Chip sealed in plastic",
    c2_p: "We drop the tag in mid-print and cover it with the next layers. The chip is protected from scratches and daily wear.",
    c3_h: "Works with phones",
    c3_p: "Android and iPhone with NFC. The other person installs nothing — they just hold the phone to the keychain.",
    pl_eye: "NFC plaques",
    pl_h: "Rate us on Google — one tap",
    pl_p: "The plaque sits by the till or on the table. A guest taps their phone and your Google profile opens for a review. No QR, no typing a link. White or black, NTAG213 chip inside, PLA.",
    pl_black: "Black version",
    pl_white: "White version",
    pl1_h: "Google reviews",
    pl1_p: "We program the chip to your Google profile. The customer taps and leaves stars instead of searching for the business.",
    pl2_h: "10 × 15 cm",
    pl2_p: "Rectangle 150 cm² — the size from the offer. Square and circle too. Larger formats are quoted separately. Custom logo or text on request.",
    pl3_h: "60 PLN gross",
    pl3_p: "One plaque with chip and print. Lead time 4–7 days. Works in a venue, clinic, shop or reception.",
    how_eye: "How it works",
    how_h: "Three steps from idea to tap",
    s1_h: "You pick the shape and color",
    s1_p: "A catalog model or your own design. Material: PLA for everyday use.",
    s2_h: "We print and hide the chip",
    s2_p: "The printer pauses halfway. We place a 25 mm NTAG213 tag and finish the print so the plastic closes over it.",
    s3_h: "You program it with one tap",
    s3_p: "The free NFC Tools app writes a link, a vCard, Wi‑Fi or a profile. You can change it later — the chip is rewritable.",
    s3_link: "Download NFC Tools",
    use_eye: "Why carry it",
    use_h: "One keychain, many uses",
    u1_h: "Contact card",
    u1_p: "Skip the paper — a tap drops your contact into their phone.",
    u2_h: "Social media",
    u2_p: "Instagram, TikTok, YouTube or a portfolio. Fast, with no typos.",
    u3_h: "Guest Wi‑Fi",
    u3_p: "A guest taps the phone and joins the network. The password stays in the keychain.",
    u4_h: "Gift and branding",
    u4_p: "A gadget shaped like a company, school or event. Small, but people remember it.",
    shop_eye: "Workshop",
    shop_h: "FDM print, not injection mold",
    shop_p: "Every keychain is built layer by layer. That means short runs, new shapes and color mixes without an expensive mold. The chip goes into a pocket during the print — no glue on the outside.",
    sp1: "Process",
    sp2: "Material",
    sp2v: "PLA",
    sp3: "Chip",
    sp4: "Memory",
    sp4v: "144 or 504 B",
    sp5: "Frequency",
    sp6: "Tag size",
    sp7: "Weight",
    sp7v: "about 5–10 g",
    sp8: "Power",
    sp8v: "no battery",
    gal_eye: "Gallery",
    gal_h: "How it looks on your keys",
    pr_eye: "Pricing",
    pr_h: "Keychain or plaque",
    pr_p: "Gross price per piece. Shape, color and chip programming included.",
    p1_h: "NFC keychain",
    p1_s: "Circle, square or drop",
    p1_l1: "About 4 cm, metal ring included",
    p1_l2: "NFC chip inside the print",
    p1_l3: "Up to 4 colors",
    p1_l4: "Link programming included",
    p2_h: "NFC plaque",
    p2_s: "Square, circle, rectangle",
    p2_l1: "Rectangle 10 × 15 cm (150 cm²)",
    p2_l2: "White or black version",
    p2_l3: "Logo or text on the front",
    p2_l4: "NFC chip for reviews / a page",
    p3_h: "Volume discount",
    p3_s: "Bigger run, lower price",
    p3_l1: "Keychains: 50 / 100 / 200 pcs → 5 / 8 / 10%",
    p3_l2: "Plaques: 5 / 15 / 30 pcs → 5 / 8 / 10%",
    p3_l3: "30% deposit, rest before shipping",
    p3_l4: "Lead time 4–7 business days",
    btn_write: "Write to us",
    per: "gross / pc.",
    from: "from",
    faq_eye: "Questions",
    faq_h: "Short and clear",
    f1_q: "Do I need an app to read the keychain?",
    f1_a: "No. The person you show it to just taps their phone. An app is only needed to write or change the content the first time.",
    f2_q: "What are TapLab NFC plaques and keychains?",
    f2_a: "Physical tags (plaques and keychains) with an NFC chip inside. Hold a phone close and it opens the link you chose — a menu, Google profile, social page or a review form. No QR code to scan.",
    f3_q: "Does my phone support NFC?",
    f3_a: "Most phones from the last few years (Android and iPhone) have NFC built in. On Android you may need to turn it on in settings — we can show you how.",
    f4_q: "Can I change the link after purchase?",
    f4_a: "Yes. On most of our products the tag is rewritable, so you can change the destination anytime without replacing the plaque or keychain.",
    f5_q: "Which shapes are available?",
    f5_a: "NFC plaques: square, circle, rectangle. NFC keychains: circle, ring, drop. Every piece can be branded.",
    f6_q: "How much does an order cost?",
    f6_a: "NFC plaques — 60 PLN gross each, NFC keychains — 13 PLN gross each. Volume discounts: from 5 pcs — 5%, from 15 — 8%, from 30 — 12%, and extra discounts from 50 pcs.",
    f7_q: "How long does production take?",
    f7_a: "Usually 4–7 business days. Orders over 175 pcs may take longer — we will tell you before you confirm.",
    f8_q: "How does payment work?",
    f8_a: "30% deposit when you place the order, the remaining 70% before shipping.",
    f9_q: "Is graphic design included?",
    f9_a: "Yes. The first two design proposals are included. Extra rounds are charged separately.",
    f10_q: "How is delivery handled?",
    f10_a: "Courier across Poland. Pickup or personal delivery is also possible in Bydgoszcz.",
    f11_q: "Who is this for?",
    f11_a: "Businesses and venues that want an easy tap to a menu, card, Google reviews or socials — restaurants, cafes, salons, shops, hotels.",
    f12_q: "How do I order?",
    f12_a: "Write through the contact form or email. We quote, set a date and treat every order individually — there is no Buy now button, so we can match the design, quantity and deadline to you. We care about the final result.",
    ct_eye: "Contact",
    ct_h: "Send an enquiry",
    ct_p: "Pick a product, add your details and optionally attach artwork. The message goes to karol.lemanczyk@taplab.pl.",
    ct_mail: "E-mail",
    ct_tel: "Phone",
    ct_loc: "Location",
    ct_pl: "Bydgoszcz",
    made_in: "Made in Poland",
    foot_info: "Information",
    foot_company: "Company details",
    foot_social: "Follow us",
    foot_terms: "Terms",
    foot_privacy: "Privacy policy",
    foot1: "TapLab · Sebastian Lemańczyk",
    foot2: "Product presentation site · 2026",
    form_product: "Product",
    form_keychain: "Keychain",
    form_plaque: "Plaque",
    form_firstname: "First name",
    form_lastname: "Last name",
    form_email: "Customer e-mail",
    form_company: "Company name (optional)",
    form_desc: "Description",
    form_file: "Artwork (optional)",
    form_file_hint: "PNG, JPG, SVG, PDF, AI, EPS, ZIP, STL, 3MF and similar.",
    form_send: "Send",
    form_ok: "Sent. The first message may require confirming karol.lemanczyk@taplab.pl.",
    form_err: "Could not send. Try again or write to karol.lemanczyk@taplab.pl.",
    form_need: "Pick a product, quantity, first name, last name, e-mail and description."
  }
};

const menuBtn = document.querySelector(".menu-btn");
const navLinks = document.querySelector(".nav-links");
const form = document.querySelector("#contact-form");
const toast = document.querySelector("#toast");

let currentLang = "pl";
let langBusy = false;

const textNodes = () =>
  document.querySelectorAll("[data-i18n], [data-i18n-html]");

const paintLang = (lang) => {
  const pack = translations[lang] || translations.pl;
  currentLang = lang;
  document.documentElement.lang = lang;
  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.getAttribute("data-i18n");
    if (pack[key]) el.textContent = pack[key];
  });
  document.querySelectorAll("[data-i18n-html]").forEach((el) => {
    const key = el.getAttribute("data-i18n-html");
    if (pack[key]) el.innerHTML = pack[key];
  });
  const themeBtnEl = document.querySelector(".theme-btn");
  if (themeBtnEl && pack.theme_toggle) themeBtnEl.setAttribute("aria-label", pack.theme_toggle);
  document.querySelectorAll("[data-lang]").forEach((btn) => {
    btn.classList.toggle("is-active", btn.getAttribute("data-lang") === lang);
  });
  document.querySelectorAll(".lang-switch").forEach((box) => {
    box.classList.toggle("is-en", lang === "en");
  });
  document.querySelectorAll(".taplab-root").forEach((el) => el.setAttribute("data-lang", lang));
  if (menuBtn) {
    const open = navLinks && navLinks.classList.contains("open");
    menuBtn.setAttribute("aria-label", open ? pack.menu_close : pack.menu_open);
  }
  try { localStorage.setItem("taplab-lang", lang); } catch (e) {}
};

const applyLang = (lang, animate) => {
  lang = lang === "en" ? "en" : "pl";
  if (lang === currentLang && animate) return;
  if (langBusy) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!animate || reduce) {
    paintLang(lang);
    return;
  }
  langBusy = true;
  const roots = document.querySelectorAll(".taplab-root");
  const nodes = textNodes();
  roots.forEach((el) => el.classList.add("lang-animating"));
  nodes.forEach((el) => {
    el.classList.remove("lang-swap-in");
    el.classList.add("lang-swap-out");
  });
  window.setTimeout(() => {
    paintLang(lang);
    nodes.forEach((el) => {
      el.classList.remove("lang-swap-out");
      el.classList.add("lang-swap-in");
    });
    window.setTimeout(() => {
      nodes.forEach((el) => el.classList.remove("lang-swap-in"));
      roots.forEach((el) => el.classList.remove("lang-animating"));
      langBusy = false;
    }, 260);
  }, 90);
};

document.querySelectorAll("[data-lang]").forEach((btn) => {
  btn.addEventListener("click", () => applyLang(btn.getAttribute("data-lang"), true));
});

let saved = "pl";
try { saved = localStorage.getItem("taplab-lang") || "pl"; } catch (e) {}
applyLang(saved === "en" ? "en" : "pl", false);

if (menuBtn && navLinks) {
  const toggleMenu = (open) => {
    const isOpen = typeof open === "boolean" ? open : !navLinks.classList.contains("open");
    navLinks.classList.toggle("open", isOpen);
    menuBtn.classList.toggle("is-open", isOpen);
    document.body.classList.toggle("menu-open", isOpen);
    if (isOpen) {
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      const y = Math.abs(parseInt(document.body.style.top || "0", 10));
      document.body.style.top = "";
      window.scrollTo(0, y);
    }
    menuBtn.setAttribute("aria-expanded", String(isOpen));
    const lang = document.documentElement.lang === "en" ? "en" : "pl";
    const pack = translations[lang];
    menuBtn.setAttribute("aria-label", isOpen ? pack.menu_close : pack.menu_open);
  };

  menuBtn.addEventListener("click", () => toggleMenu());
  navLinks.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => toggleMenu(false));
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth > 900) toggleMenu(false);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") toggleMenu(false);
  });
}

const reveals = document.querySelectorAll(".reveal");
if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.14, rootMargin: "0px 0px -40px 0px" }
  );
  reveals.forEach((el) => observer.observe(el));
} else {
  reveals.forEach((el) => el.classList.add("in"));
}

const bar = document.querySelector(".scroll-progress");
const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
if (bar && !reduce) {
  const updateBar = () => {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const p = max > 0 ? window.scrollY / max : 0;
    bar.style.width = `${Math.min(1, Math.max(0, p)) * 100}%`;
  };
  updateBar();
  window.addEventListener("scroll", updateBar, { passive: true });
}

const fine = window.matchMedia("(pointer: fine)").matches;
if (fine && !reduce) {
  const root = document.documentElement;
  window.addEventListener("pointermove", (e) => {
    root.style.setProperty("--mx", `${e.clientX}px`);
    root.style.setProperty("--my", `${e.clientY}px`);
  }, { passive: true });

  const tiltSel = document.querySelectorAll(".hero-visual, .card, .price, .plaque-hero");
  tiltSel.forEach((el) => {
    el.addEventListener("pointermove", (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 8}deg) translateY(-4px)`;
    });
    el.addEventListener("pointerleave", () => {
      el.style.transform = "";
    });
  });
}

const ORDER_MAIL = "karol.lemanczyk@taplab.pl";
const statusEl = document.querySelector("#form-status");
const setFormStatus = (type, text) => {
  if (!statusEl) return;
  statusEl.hidden = false;
  statusEl.className = `form-status ${type === "ok" ? "is-ok" : "is-err"}`;
  statusEl.textContent = text;
};

const syncQty = (box) => {
  const qty = form && form.querySelector(`[name="${box.dataset.qty}"]`);
  if (!qty) return;
  qty.disabled = !box.checked;
  if (box.checked) qty.focus();
};

const selectProduct = (name) => {
  if (!form) return;
  const map = { Breloczek: "chce_breloczek", Tabliczka: "chce_tabliczka" };
  const field = map[name];
  if (!field) return;
  const box = form.querySelector(`[name="${field}"]`);
  if (!box) return;
  box.checked = true;
  syncQty(box);
};

if (form) {
  form.querySelectorAll('input[type="checkbox"][data-qty]').forEach((box) => {
    box.addEventListener("change", () => syncQty(box));
  });
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const lang = document.documentElement.lang === "en" ? "en" : "pl";
    const pack = translations[lang];
    const wantKey = form.querySelector('[name="chce_breloczek"]')?.checked;
    const wantPlaque = form.querySelector('[name="chce_tabliczka"]')?.checked;
    const first = String(form.imie?.value || "").trim();
    const last = String(form.nazwisko?.value || "").trim();
    const email = String(form.email?.value || "").trim();
    const desc = String(form.opis?.value || "").trim();
    if ((!wantKey && !wantPlaque) || !first || !last || !email || !desc) {
      setFormStatus("err", pack.form_need);
      return;
    }
    const parts = [];
    if (wantKey) parts.push(`Breloczek x${form.ilosc_breloczek.value || 1}`);
    if (wantPlaque) parts.push(`Tabliczka x${form.ilosc_tabliczka.value || 1}`);
    const data = new FormData(form);
    data.append("produkt", parts.join(", "));
    data.append("_subject", `TapLab — ${parts.join(", ")} — ${first} ${last}`);
    data.append("_template", "table");
    data.append("_captcha", "false");
    data.append("do", ORDER_MAIL);
    const btn = form.querySelector("[type=submit]");
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`https://formsubmit.co/ajax/${ORDER_MAIL}`, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" }
      });
      if (!res.ok) throw new Error("send failed");
      form.reset();
      form.querySelectorAll(".qty").forEach((q) => { q.disabled = true; });
      setFormStatus("ok", pack.form_ok);
    } catch (err) {
      setFormStatus("err", pack.form_err);
    } finally {
      if (btn) btn.disabled = false;
    }
  });
}

document.querySelectorAll("[data-order]").forEach((link) => {
  link.addEventListener("click", () => selectProduct(link.getAttribute("data-order")));
});

const themeBtn = document.querySelector(".theme-btn");
const themeMedia = window.matchMedia("(prefers-color-scheme: dark)");
const themeColor = (mode) => (mode === "dark" ? "#121214" : "#EEF0F3");
const applyTheme = (theme, manual, event) => {
  const next = theme === "dark" ? "dark" : "light";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const paint = () => {
    document.documentElement.setAttribute("data-theme", next);
    document.querySelectorAll(".taplab-root").forEach((el) => el.setAttribute("data-theme", next));
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", themeColor(next));
  };
  paint();
  document.documentElement.style.backgroundColor = themeColor(next);
  if (document.body) document.body.style.backgroundColor = themeColor(next);
  if (manual && !reduce) {
    document.querySelectorAll(".taplab-root").forEach((el) => {
      el.classList.remove("theme-animating", "to-dark", "to-light");
      void el.offsetWidth;
      el.classList.add("theme-animating", next === "dark" ? "to-dark" : "to-light");
    });
    window.setTimeout(() => {
      document.querySelectorAll(".taplab-root").forEach((el) => {
        el.classList.remove("theme-animating", "to-dark", "to-light");
      });
    }, 430);
  }
  try {
    if (manual) localStorage.setItem("taplab-theme-manual", next);
  } catch (e) {}
};
const systemTheme = () => (themeMedia.matches ? "dark" : "light");
let manualTheme = null;
try { manualTheme = localStorage.getItem("taplab-theme-manual"); } catch (e) {}
applyTheme(manualTheme || systemTheme(), false);
if (themeBtn) {
  themeBtn.addEventListener("click", (event) => {
    const now = document.documentElement.getAttribute("data-theme") === "dark" ? "light" : "dark";
    applyTheme(now, true, event);
  });
}
const onSys = () => {
  let locked = null;
  try { locked = localStorage.getItem("taplab-theme-manual"); } catch (e) {}
  if (!locked) applyTheme(systemTheme(), false);
};
if (themeMedia.addEventListener) themeMedia.addEventListener("change", onSys);
else if (themeMedia.addListener) themeMedia.addListener(onSys);
